  <div class="row mt-3 g-2 flex-wrap px-4 ">
    <!-- Total Trust Client Enquiries -->
    <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 d-flex">
      <div class="w-100 h-100">
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
            <div class=" circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
              <i class="fa-solid fa-clipboard-list fa-lg text-primary-blue"></i>
            </div>
            <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
              <p class="mb-1 text-xs text-white">Total Trust Client Enquiries</p>
              <p class="m-0 fw-bold text-white">0</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Total Trusts -->
    <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 d-flex">
      <div class="w-100 h-100">
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
            <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
              <i class="fa-solid fa-scale-balanced fa-lg text-primary-blue"></i>
            </div>
            <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
              <p class="mb-1 text-xs text-white">Total Trusts</p>
              <p class="m-0 fw-bold text-white">{{ trust_directory_entries_count }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- System Users -->
    <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 d-flex">
      <div class="w-100 h-100">
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
            <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
              <i class="fa-solid fa-users fa-lg text-primary-blue"></i>
            </div>
            <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
              <p class="mb-1 text-xs text-white">System Users</p>
              <p class="m-0 fw-bold text-white">{{ total_user_count }}</p>
              <p class="m-0 text-white small">{{ admins }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Leads -->
    <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 d-flex">
      <div class="w-100 h-100">
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
            <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
              <i class="fa-solid fa-arrow-up-right-from-square fa-lg text-primary-blue"></i>
            </div>
            <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
              <p class="mb-1 text-xs text-white">Leads</p>
              <p class="m-0 fw-bold text-white">{{ total_lead_count }}</p>
              <p class="m-0 text-white small">{{ admins }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Types of Trusts -->
    <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 d-flex">
      <div class="w-100 h-100">
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
            <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
              <i class="fa-solid fa-shield-halved fa-lg text-primary-blue"></i>
            </div>
            <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
              <p class="mb-1 text-xs text-white">Types of Trusts</p>
              <p class="m-0 fw-bold text-white">0</p>
              <p class="m-0 text-white small">{{ applications }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Total Number of Trustees -->
    <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 d-flex">
      <div class="w-100 h-100">
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
            <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
              <i class="fa-solid fa-list-check fa-lg text-primary-blue"></i>
            </div>
            <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
              <p class="mb-1 text-xs text-white">Total Number of Trustees</p>
              <p class="m-0 fw-bold text-white">{{ total_trust_count }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Upcoming Meetings -->
    <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 d-flex">
      <div class="w-100 h-100">
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
            <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
              <i class="fa-solid fa-handshake fa-lg text-primary-blue"></i>
            </div>
            <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
              <p class="mb-1 text-xs text-white">Upcoming Meetings</p>
              <p class="m-0 fw-bold text-white">0</p>
              <p class="m-0 text-white small">{{ admins }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Compliant Trusts -->
    <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 d-flex">
      <div class="w-100 h-100">
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
            <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
              <i class="fa-solid fa-check-double fa-lg text-primary-blue"></i>
            </div>
            <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
              <p class="mb-1 text-xs text-white">Compliant Trusts</p>
              <p class="m-0 fw-bold text-white">0</p>
              <p class="m-0 text-white small">{{ admins }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Non-Compliant Trusts -->
    <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 d-flex">
      <div class="w-100 h-100">
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
            <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
              <i class="fa-solid fa-triangle-exclamation fa-lg text-primary-blue"></i>
            </div>
            <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
              <p class="mb-1 text-xs text-white">Non-Compliant Trusts</p>
              <p class="m-0 fw-bold text-white">0</p>
              <p class="m-0 text-white small">{{ applications }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Total Tasks -->
    <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 d-flex">
      <div class="w-100 h-100">
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
            <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
              <i class="fa-solid fa-bars-progress fa-lg text-primary-blue"></i>
            </div>
            <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
              <p class="mb-1 text-xs text-white">Total Tasks</p>
              <p class="m-0 fw-bold text-white">0</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Active Clients -->
    <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 d-flex">
      <div class="w-100 h-100">
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
            <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
              <i class="fa-solid fa-user-shield fa-lg text-primary-blue"></i>
            </div>
            <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
              <p class="mb-1 text-xs text-white">Active Clients</p>
              <p class="m-0 fw-bold text-white">{{ total_trust_directory_count }}</p>
              <p class="m-0 text-white small">{{ admins }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pending Tasks -->
    <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 d-flex">
      <div class="w-100 h-100">
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
            <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
              <i class="fa-solid fa-check-double fa-lg text-primary-blue"></i>
            </div>
            <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
              <p class="mb-1 text-xs text-white">Pending Tasks</p>
              <p class="m-0 fw-bold text-white">0</p>
              <p class="m-0 text-white small">{{ admins }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Chart Section -->
  <div class="row mt-2 d-flex align-items-stretch px-4 m-1">
    <div class="card shadow-sm rounded-lg h-100">
      <div class="card-body p-1">
        <div class="highcharts-figure compact-chart">
          <div ref="trustChartContainer" id="trustChartContainer" class="chart-container"></div>
          <p class="highcharts-description">Client trends over time</p>
        </div>
      </div>
    </div>
  </div>

